import { RefundOrder } from "../../views/Payment/OrderRefund";
import { apiSlice } from "../apiSlice";
import { OrderRefunding } from "./dashboardService";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const dashboardService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRefundOrders: builder.query<RefundOrder, any>({
      query: (status) => ({
        url: `https://adminhttps-getrefundrequests-${API_BASE_DOMAIN}-uc.a.run.app?&status=${status}`,
        method: "GET",
        responseHandler: (response) => response.json(),
      }),
    }),
    orderRefunding: builder.mutation<any, OrderRefunding>({
      query: (data) => ({
        url: `https://adminhttps-processrefund-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.json(),
      }),
    }),
  }),
});

export const {
  useLazyGetRefundOrdersQuery,
  useOrderRefundingMutation,
} = dashboardService;